import { INotificationItem } from "../../app/modules/core/_models";
import { IRegistrationDropdownData } from "../../app/PublicPages/core/models";
import { StoreAction } from "../../utils/actions";

/** State type */
interface authState {
    registrationDropdownData: IRegistrationDropdownData | null;
}

/** Action type */
interface fetchRegistrationDropdownDataAction {
    type: string;
    payload: IRegistrationDropdownData | null;
}

const initialState: authState = {
    registrationDropdownData: null,
};

export default function authReducer(
    state: authState = initialState,
    action: fetchRegistrationDropdownDataAction
): authState {

    switch (action.type) {

        //  Replace full list
        case StoreAction.FETCH_REGISTRATION_DROPDOWN_DATA:
            return {
                ...state,
                registrationDropdownData: action.payload as IRegistrationDropdownData,
            };
            
        default:
            return state;
    }
}

